import { brandPrimaryHover, hotPink, titles } from '../../../../web/styles/colors';
import {
	ActionsColumnStyle,
	CreationDateColumnStyle,
	GripperColumnStyle,
	IndustriesColumnStyle,
	NameColumnStyle,
} from '../IndustryTemplatesTable/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	actionsCol: {
		...ActionsColumnStyle,
	},
	actionsColMoreButton: {
		marginLeft: 10,
	},
	container: {
		alignItems: 'center',
		background: '#fff',
		boxSizing: 'border-box',
		display: 'flex',
		padding: '20px 0',
	},
	creationDateCol: {
		...CreationDateColumnStyle,
		color: titles,
		fontSize: 12,
	},
	gripperCol: {
		...GripperColumnStyle,
		alignItems: 'center',
		display: 'flex',
	},
	industriesCol: {
		...IndustriesColumnStyle,
		color: titles,
		fontSize: 12,
	},
	nameCol: {
		...NameColumnStyle,
		alignItems: 'center',
		display: 'flex',
	},
	nameColButton: {
		':hover': {
			textDecoration: 'underline',
		},
		alignItems: 'center',
		color: brandPrimaryHover,
		display: 'flex',
		fontSize: 16,
		maxWidth: '80%',
	},
	newItem: {
		color: hotPink,
		fontSize: 12,
	},
});
